// Regras da reunião do condomínio.
//
// A relação entre data e status é regra de domínio, não detalhe da tela: o
// espelho dela está no gatilho `reunioes_status_coerente` (migration 0053), que
// é quem recusa de verdade. Aqui a checagem existe para explicar antes de
// gravar — e fica fora do componente para poder ser testada sem montar a aba.

export const STATUS_REUNIAO = ['Realizada', 'Agendada', 'Cancelada'] as const;
export type StatusDeReuniao = (typeof STATUS_REUNIAO)[number];

/** Status que faz sentido para uma reunião cuja data já passou. */
export const STATUS_PARA_DATA_PASSADA: StatusDeReuniao = 'Realizada';

/**
 * Data anterior a hoje. Hoje não conta como passado — a reunião da tarde ainda
 * vai acontecer.
 */
export function jaPassou(data: string): boolean {
  if (!data) return false;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  // `new Date('2026-08-30')` é UTC; sem o ajuste, o dia vira o anterior.
  const [ano, mes, dia] = data.slice(0, 10).split('-').map(Number);
  if (!ano || !mes || !dia) return false;
  return new Date(ano, mes - 1, dia).getTime() < hoje.getTime();
}

/** Reunião que ainda não aconteceu — a única que pode ser excluída. */
export function aindaVaiAcontecer(data: string): boolean {
  if (!data) return false;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const [ano, mes, dia] = data.slice(0, 10).split('-').map(Number);
  if (!ano || !mes || !dia) return false;
  return new Date(ano, mes - 1, dia).getTime() > hoje.getTime();
}

/**
 * "Agendada" é uma promessa sobre o futuro.
 *
 * Uma reunião de março cadastrada em setembro com esse status entra na agenda
 * como compromisso pendente e nos alertas de vencimento, e ninguém nunca vai
 * comparecer. O que aconteceu é Realizada; o que não aconteceu é Cancelada.
 *
 * Devolve a frase do erro, ou nulo quando data e status combinam.
 */
export function erroDeStatus(data: string, status: string): string | null {
  if (status !== 'Agendada' || !jaPassou(data)) return null;
  return 'Reunião com data no passado não pode ficar como Agendada: use Realizada ou Cancelada.';
}
